import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class FlotsamJetsamSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.FLOTSAM_JETSAM;
}

export default FlotsamJetsamSalvageableTileEntity;
